import script from "./GalleryDetailSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryDetailSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./GalleryDetailSkeleton.vue?vue&type=style&index=0&id=de8a4766&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de8a4766"]])

export default __exports__